import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { themeGet } from "styled-system";
import Box from "../Box";

import DefaultContainer from "./DefaultContainer";

import TextF1 from "../TextF1";
import TextF2 from "../TextF2";
import TextF3 from "../TextF3";
import TextF4 from "../TextF4";
import TextF6 from "../TextF6";
import TextF7 from "../TextF7";
//
// const Test = styled(Heading)`
//  font-family: 'tt-norms-pro-bold';
// `

const StyledSubHeading = styled(TextF6)`
  color: #19ca94;
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  font-weight: normal;
`;

const SubHeading = StyledSubHeading.withComponent("h3");

const StyledHeading = styled(TextF6)`
  font-family: ${themeGet("fonts.TTNormsProBold")};
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

const Heading = StyledHeading.withComponent("h2");

const StyledBox = styled(Box)`
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  margin-left: -1.5rem;
  margin-right: -1rem;
  @media screen and (min-width: 30em) {
    margin-left: -2.5rem;
    margin-right: -2rem;
  }
`;

export default class NoteBox extends React.Component {
  static defaultProps = {
    heading: "Title",
    description: "description text"
  };

  state = {
    heading: this.props.heading,
    description: this.props.description
  };

  render() {
    return (
      <DefaultContainer>
        <StyledBox
          px={[3, 4]}
          py={4}
          mt={5}
          mb={5}
          borderLeft="8px solid #19ca94"
        >
          <StyledSubHeading m={0}>
            <FormattedMessage id="section.block.example" />
          </StyledSubHeading>
          <Heading m={0}>{this.state.heading}</Heading>
          <TextF7
            m={0}
            dangerouslySetInnerHTML={{ __html: this.state.description }}
          />
        </StyledBox>
      </DefaultContainer>
    );
  }
}
